import brandPortalOrdersbrandOrderTokenOrderFulfilment from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-fulfilment";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var DiscrepancyInPayoutTotalIA = function DiscrepancyInPayoutTotalIA(_ref) {
  var brandOrder = _ref.brandOrder;
  if (brandOrder) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "XAYTV2",
      defaultMessage: [{
        "type": 0,
        "value": "Antes de contactar a nossa equipa de apoio, recomendamos que verifique novamente o seu pagamento e tenha em conta estas informações:"
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
      step: 1
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "meI9PQ",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Reveja o pagamento"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": consulte o cálculo completo na "
      }, {
        "children": [{
          "type": 0,
          "value": "página de detalhes da encomenda"
        }],
        "type": 8,
        "value": "OrderDetailLinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderDetailLinkFormatting: function OrderDetailLinkFormatting(chunks) {
          var _brandOrder$brand_ord, _brandOrder$brand_ord2;
          return orderDetailLinkFormatting(chunks, (_brandOrder$brand_ord = (_brandOrder$brand_ord2 = brandOrder.brand_order) === null || _brandOrder$brand_ord2 === void 0 ? void 0 : _brandOrder$brand_ord2.token) !== null && _brandOrder$brand_ord !== void 0 ? _brandOrder$brand_ord : "");
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 2
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "/23Rwc",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Verifique se há devoluções ou ajustes"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": devoluções, ajustes de envio ou descontos promocionais podem afetar o seu pagamento. Estes montantes estão discriminados nos detalhes da transação. Se algum artigo for assinalado como danificado ou em falta, é deduzido do pagamento dessa encomenda."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 3
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "d6yt+p",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Considere as comissões"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": as comissões são calculadas com base no subtotal das encomendas."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 4
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "lEvLnb",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Tenha em conta as taxas de processamento"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": as taxas de processamento de pagamento afetam o valor do pagamento final. A estrutura de taxas depende da opção de pagamento que selecionou."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 5
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "GgW3sY",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Contacte-nos para obter esclarecimentos"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": se ainda tiver dúvidas ou se algo não estiver correto com o seu pagamento, não hesite em contactar-nos."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })))));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "omcjTV",
    defaultMessage: [{
      "type": 0,
      "value": "Antes de contactar a nossa equipa de apoio, recomendamos que verifique novamente o seu pagamento e tenha em conta estas informações:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IzZ4Mb",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Reveja o pagamento"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": para consultar o cálculo completo de uma encomenda específica, aceda a Encomendas e depois clique na página de detalhes da encomenda. Deslize para baixo até à secção Recebeu um pagamento! e selecione Ver resumo do pagamento. Aí encontrará um cálculo detalhado do pagamento."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "SWyxt7",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Verifique se há devoluções ou ajustes"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": devoluções, ajustes de envio ou descontos promocionais podem afetar o seu pagamento. Estes montantes são discriminados no seu resumo de pagamentos. Se algum artigo for assinalado como danificado ou em falta, é deduzido do pagamento dessa encomenda."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "OGBrmv",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Considere as comissões"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": as comissões são calculadas com base no subtotal das encomendas."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "mU015p",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Procure taxas de processamento"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": as taxas de processamento de pagamento afetam o valor do pagamento final. A estrutura de taxas depende da opção de pagamento que selecionou."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 5
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "xUp5Oe",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Contacte-nos para obter esclarecimentos"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": se ainda tiver dúvidas ou se algo não estiver correto com o seu pagamento, não hesite em contactar-nos."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var orderDetailLinkFormatting = function orderDetailLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenOrderFulfilment(brandOrderToken, {
      sync: "true"
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};